import type { ContainerProps } from "../types";
import clsx from "clsx";

export const Footer: React.FC<ContainerProps> = ({ children, className }) => (
    <footer className={clsx("text-center p-4", className)}>
        {children}
    </footer>
);

export interface DefaultFooterProps {
    className?: string;
    text?: React.ReactNode;
    footer?: React.ReactNode;
    isBordered?: boolean;
    isBlurred?: boolean;
    isSticky?: boolean;
}

export const DefaultFooter: React.FC<DefaultFooterProps> = ({ className, text, footer, isBordered, isBlurred, isSticky }) => {
    return (
        <Footer className={clsx(
            "bg-transparent",
            {
                "border-t-1 border-default-200": isBordered,
                "backdrop-blur-lg bg-background/70": isBlurred,
                "sticky bottom-0 w-full z-40": isSticky,
                className
            }
        )}>
            <p className="text-small text-default-400">{footer || `© ${text}. All Rights Reserved.`}</p>
        </Footer>
    )
}